var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.378 3.082C2.98023e-08 3.62 0 5.22 0 8.417V9.991C0 15.629 4.239 18.366 6.899 19.527C7.62 19.842 7.981 20 9 20C10.02 20 10.38 19.842 11.101 19.527C13.761 18.365 18 15.63 18 9.991V8.417C18 5.219 18 3.62 17.622 3.082C17.245 2.545 15.742 2.03 12.735 1.001L12.162 0.805C10.595 0.268 9.812 0 9 0C8.189 0 7.405 0.268 5.838 0.805L5.265 1C2.258 2.03 0.755 2.545 0.378 3.082ZM12.06 8.5C12.1256 8.42646 12.1761 8.34072 12.2085 8.24767C12.241 8.15463 12.2548 8.0561 12.2492 7.95772C12.2436 7.85934 12.2186 7.76302 12.1758 7.67428C12.1329 7.58553 12.073 7.5061 11.9995 7.4405C11.926 7.37491 11.8402 7.32444 11.7472 7.29198C11.6541 7.25952 11.5556 7.2457 11.4572 7.25132C11.3588 7.25694 11.2625 7.28188 11.1738 7.32472C11.085 7.36756 11.0056 7.42746 10.94 7.501L7.929 10.875L7.059 9.901C6.92604 9.75408 6.74033 9.66574 6.54245 9.65529C6.34457 9.64485 6.15059 9.71313 6.0029 9.84524C5.8552 9.97735 5.76579 10.1625 5.75419 10.3604C5.74259 10.5582 5.80975 10.7525 5.941 10.901L7.369 12.501C7.43935 12.5798 7.52556 12.6429 7.62198 12.686C7.7184 12.7292 7.82286 12.7515 7.9285 12.7515C8.03415 12.7515 8.1386 12.7292 8.23502 12.686C8.33144 12.6429 8.41765 12.5798 8.488 12.501L12.06 8.5Z",
    fill: "#1ECB4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment_icon.51cbe4f9a62675e46c42638e9845409a.svg";
export { ForwardRef as ReactComponent };